import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	CHECK_ALL_NOTIFICATIONS,
	CHECK_NOTIFICATION,
	GET_NOTIFICATIONS,
	GET_ALL_NOTIFICATIONS
} from '../constants/Notification';
import {
	getNotificationsSuccess,
	getNotificationsError,
	checkNotificationSuccess,
	checkNotificationError,
	checkAllNotificationsSuccess,
	checkAllNotificationsError,
	getAllNotificationsSuccess,
	getAllNotificationsError,
} from "../actions/Notification";

import {
	checkAllNotificationsService,
	checkNotificationService,
	getNotificationsService,
} from 'redux/services/Notification';

export function* getNotificationsSaga() {
	yield takeEvery(GET_NOTIFICATIONS, function* ({ payload }) {
		try {
			const { query } = payload;
			const data = yield call(getNotificationsService, query);
			if (data.message) {
				yield put(getNotificationsError(data.message));
			} else {
				yield put(getNotificationsSuccess(data));
			}
		} catch (err) {
			yield put(getNotificationsError(err));
		}
	});
}

export function* getAllNotificationsSaga() {
	yield takeEvery(GET_ALL_NOTIFICATIONS, function* ({ payload }) {
		try {
			const data = yield call(getNotificationsService, { unseen: false });
			if (data.message) {
				yield put(getAllNotificationsError(data.message));
			} else {
				yield put(getAllNotificationsSuccess(data));
			}
		} catch (err) {
			yield put(getAllNotificationsError(err));
		}
	});
}

export function* checkNotificationSaga() {
	yield takeEvery(CHECK_NOTIFICATION, function* ({ payload }) {
		try {
			const { id, cb } = payload;
			const data = yield call(checkNotificationService, id);
			if (data.message) {
				yield put(checkNotificationError(data.message));
			} else {
				yield call(cb);
				yield put(checkNotificationSuccess(data));
			}
		} catch (err) {
			yield put(checkNotificationError(err));
		}
	});
}

export function* checkAllNotificationsSaga() {
	yield takeEvery(CHECK_ALL_NOTIFICATIONS, function* ({ payload }) {
		try {
			const { cb } = payload;
			const data = yield call(checkAllNotificationsService);
			if (data.message) {
				yield put(checkAllNotificationsError(data.message));
			} else {
				yield call(cb);
				yield put(checkAllNotificationsSuccess(data));
			}
		} catch (err) {
			yield put(checkAllNotificationsError(err));
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getNotificationsSaga),
		fork(getAllNotificationsSaga),
		fork(checkNotificationSaga),
		fork(checkAllNotificationsSaga),
	]);
}
